import React from "react";
import ReactDOM from "react-dom";
import App from "./EstablishmentApp/App";
import { PlatformContextProvider } from "./shared/context/PlatformContext";
import Router from "./EstablishmentApp/components/Router";

const root = document.getElementById("establishment-app");

const {
    feedBaseUrl,
    country,
    locale,
    brand,
    service,
    siteTitle,
    pageTitle,
    metaTitle,
    metaDescription,
    socialDescription,
    metaImage,
    routerBasename,
    mainPageUrl,
    contactPageUrl,
    workplacePageUrl,
    autoschadeRumblePageUrl,
    detailCards,
} = root.dataset;
if (!feedBaseUrl)
    throw new Error("Feed is required in the establishment app container");

const parsedDetailCards = JSON.parse(detailCards);

ReactDOM.render(
    <PlatformContextProvider>
        <Router basename={routerBasename}>
            <App
                feedBaseUrl={feedBaseUrl}
                country={country}
                locale={locale}
                defaultBrand={brand}
                defaultService={service}
                mainPageUrl={mainPageUrl}
                contactPageUrl={contactPageUrl}
                workplacePageUrl={workplacePageUrl}
                autoschadeRumblePageUrl={autoschadeRumblePageUrl}
                siteTitle={siteTitle}
                pageTitle={pageTitle}
                metaTitle={metaTitle}
                metaDescription={metaDescription}
                socialDescription={socialDescription}
                metaImage={metaImage}
                routerBasename={routerBasename}
                detailCards={parsedDetailCards || {}}
            />
        </Router>
    </PlatformContextProvider>,
    root
);
